import React, { useState, useContext } from 'react'
import './SkySwitch.scss'
import FlexView from 'react-flexview/lib'
import { InsurancePurchaseContextStore } from '../../../context/InsuracePurchaseContext'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'
import DataLayerService from '../../../services/DataLayerService'
var classNames = require('classnames')

export const SkySwitch = ({ keys, onSelect, ...props }) => {
  const [lkeys, setKeys] = useState(keys)
  const select = (index) => {
    setKeys(
      lkeys.map((k, kindex) =>
        index == kindex
          ? { title: lkeys[kindex].title, selected: true }
          : { title: lkeys[kindex].title, selected: false }
      )
    )
    onSelect && onSelect(lkeys[index])
  }

  return (
    <FlexView vAlignContent={'center'} className="sky-switch-container">
      {lkeys.map((item, index) => (
        <div
          key={index}
          onClick={() => select(index)}
          className={classNames(
            'sky-switch-value',
            { selected: item.selected },
            { 'not-selected': !item.selected }
          )}>
          <div className="text-small">{item.title}</div>
        </div>
      ))}
    </FlexView>
  )
}

export const MonthlyYearlySwitch = (props) => {
  const insuranceContext = useContext(InsurancePurchaseContextStore)
  const offersContext = useContext(BuyingInsuranceContextStore)

  const switchToMonthly = () => {
    insuranceContext.setSelectedOption(
      offersContext.monthlyOffers.filter(
        (i) =>
          i.liabilityLimit == insuranceContext.selectedOption.liabilityLimit
      )[0]
    )
    DataLayerService.pushToDataLayer({
      event: 'yearly-to-monthly-switch',
      at: window.location.pathname,
    })
  }

  const switchToYearly = () => {
    insuranceContext.setSelectedOption(
      offersContext.annualOffers.filter(
        (i) =>
          i.liabilityLimit == insuranceContext.selectedOption.liabilityLimit
      )[0]
    )
    DataLayerService.pushToDataLayer({
      event: 'monthly-to-yearly-switch',
      at: window.location.pathname,
    })
  }

  if (
    !FirebaseService.getBoolean(FirebaseConfigKey.MONTHLY_AVAILABLE) &&
    FirebaseService.getBoolean(FirebaseConfigKey.ANNUAL_AVAILABLE)
  )
    return <div />

  return (
    <FlexView className="margin-bottom-basic" vAlignContent={'center'}>
      <div className="text-small gray margin-right-small">Plans:</div>
      <SkySwitch
        onSelect={(item) =>
          item.title == 'Monthly' ? switchToMonthly() : switchToYearly()
        }
        keys={[
          {
            title: 'Monthly',
            selected:
              insuranceContext.selectedOption.billingPeriod ==
              InsuranceBillingPeriod.MONTH,
          },
          {
            title: 'Annual',
            selected:
              insuranceContext.selectedOption.billingPeriod ==
              InsuranceBillingPeriod.YEAR,
          },
        ]}
      />
    </FlexView>
  )
}
